module.exports = __webpack_public_path__ + "img/banner.401ba452.jpg";